import { cn } from '@/context/global/utils/cn';

export type IconSidebarRightCollapseProps = {
  className?: string;
  size?: number;
};

export default function IconSidebarRightCollapse({
  className = '',
  size = 24,
}: IconSidebarRightCollapseProps) {
  return (
    <svg
      className={cn('text-white', className)}
      width={size}
      height={size}
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6691 1.66602V24.949M1.66211 4.57638C1.66211 3.80451 1.96874 3.06424 2.51454 2.51844C3.06034 1.97264 3.8006 1.66602 4.57248 1.66602H22.0347C22.8066 1.66602 23.5468 1.97264 24.0926 2.51844C24.6384 3.06424 24.945 3.80451 24.945 4.57638V22.0386C24.945 22.8105 24.6384 23.5507 24.0926 24.0965C23.5468 24.6423 22.8066 24.949 22.0347 24.949H4.57248C3.8006 24.949 3.06034 24.6423 2.51454 24.0965C1.96874 23.5507 1.66211 22.8105 1.66211 22.0386V4.57638Z"
        stroke="white"
        strokeWidth="1.66307"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9375 10.397L11.8479 13.3073L8.9375 16.2177"
        stroke="white"
        strokeWidth="1.66307"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
